<template>
	<div>
		<div class="h-survey">
			<!--  <div class="h-header" :style="{'background-color':page.color}">
       <div class="title">
         <span class="ic-chat" ><img style="width: 24px;" src="https://omnisales.worldfone.vn/portal/assets/images/livechat/icon-white-64x64.png" alt=""></span>
         <h1 class="list-title">{{page.title_survey_heading}}</h1>
         <p class="list-desc" v-html="page.title_instruction_text"></p>
       </div>
       <div class="head-action">
         <i class="fas fa-times" v-on:click="minimize"></i>
       </div>
     </div> -->

			<div class="h-header" :style="{'background-color':page.color}">
				<div class="widget-header--top-wrapper">
					
					<div class="head-action hidden">
						<i class="fas fa-times" v-on:click="minimize"></i>
					</div>
				</div>

				<div class="wrap-header-middle">
					
					<div class="logo text-center" v-if="page.logo">
						<img :src="page.logo" :title="page.title_survey_heading">
					</div>
					<div class="widget-header-title text-center">
						{{$t('title_survey_heading')}}
					</div>
					<div class="title text-center">
						<p class="list-desc" v-html="$t('title_instruction_text')"></p>
						<div class="social-logo">
							<div class="inner-social-logo">
								<div v-if="page.socials && page.socials.phone">
									<a :href="'tel:'+page.socials.phone">
										<img class="phone-logo"
											src="https://omnisales.worldfone.vn/portal/assets/images/icon/phone.svg" alt="">
									</a>
								</div>
								<div v-if="page.socials && page.socials.facebook && page.socials.facebook.url">
									<a :href="page.socials.facebook.url" target="_blank">
										<img class="fb-logo"
											src="data:image/svg+xml,%3C?xml%20version%3D%221.0%22%20?%3E%3Csvg%20width%3D%2230%22%20height%3D%2230%22%20viewBox%3D%220%200%2030%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Crect%20width%3D%2230%22%20height%3D%2230%22%20rx%3D%2215%22%20fill%3D%22%23007FFF%22/%3E%3Crect%20x%3D%224.28564%22%20y%3D%226%22%20width%3D%2221.4286%22%20height%3D%2218.8571%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M14.9478%2014.5713C14.8228%2014.5917%2014.6974%2014.6104%2014.5715%2014.6276C14.6974%2014.6104%2014.8228%2014.5917%2014.9478%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7507%2014.5713C14.691%2014.5823%2014.6313%2014.5923%2014.5715%2014.6026C14.6313%2014.5923%2014.691%2014.5823%2014.7507%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M15.0126%2014.5713C14.8663%2014.5878%2014.7192%2014.6024%2014.5715%2014.6148C14.7192%2014.6024%2014.8663%2014.5878%2015.0126%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.783%2014.5713C14.7128%2014.5807%2014.642%2014.5894%2014.5715%2014.5976C14.642%2014.5894%2014.7128%2014.5807%2014.783%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7299%2014.5713C14.6773%2014.5825%2014.6244%2014.5937%2014.5715%2014.6045C14.6244%2014.5937%2014.6773%2014.5825%2014.7299%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.6992%2014.5713C14.6567%2014.5834%2014.6141%2014.5949%2014.5715%2014.6068C14.6141%2014.5949%2014.6567%2014.5834%2014.6992%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7107%2014.5713C14.6645%2014.5834%2014.618%2014.5958%2014.5715%2014.6075C14.618%2014.5958%2014.6645%2014.5836%2014.7107%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.7194%2014.5713C14.6704%2014.5827%2014.621%2014.5935%2014.5715%2014.6045C14.621%2014.5935%2014.6704%2014.5827%2014.7194%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.8087%2014.5713C14.7297%2014.5779%2014.6507%2014.5839%2014.5715%2014.5891C14.6507%2014.5839%2014.7297%2014.5779%2014.8087%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M15.0417%2014.5713C14.8856%2014.5814%2014.7288%2014.5894%2014.5715%2014.5946C14.7288%2014.5894%2014.8856%2014.5814%2015.0417%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.8206%2014.5713C14.7377%2014.574%2014.6546%2014.5761%2014.5715%2014.5775C14.6546%2014.5761%2014.7377%2014.574%2014.8206%2014.5713Z%22%20fill%3D%22black%22/%3E%3Cpath%20d%3D%22M14.1547%2012.3174L9.29419%2017.4636L13.7176%2015.0365L16.0288%2017.4636L20.8621%2012.3174L16.4877%2014.7019L14.1547%2012.3174Z%22%20fill%3D%22%23448AFF%22/%3E%3Cpath%20d%3D%22M15%200C6.717%200%200%206.717%200%2015C0%2023.283%206.717%2030%2015%2030C23.283%2030%2030%2023.283%2030%2015C30%206.717%2023.283%200%2015%200ZM15.1172%2023.0294C14.1886%2023.0294%2013.2923%2022.8983%2012.4491%2022.6554L9.42421%2024.375V21.14C7.39815%2019.5982%206.10428%2017.2501%206.10428%2014.6203C6.10428%209.97581%2010.1395%206.21094%2015.1172%206.21094C20.0951%206.21094%2024.1301%209.97581%2024.1301%2014.6203C24.1301%2019.2643%2020.0951%2023.0294%2015.1172%2023.0294V23.0294Z%22%20fill%3D%22%23007FFF%22/%3E%3C/svg%3E"
											alt="">
									</a>
								</div>
								<div v-if="page.socials && page.socials.zalo && page.socials.zalo.url">
									<a :href="page.socials.zalo.url" target="_blank">
										<img class="fb-logo"
											src="data:image/svg+xml,%3C?xml%20version%3D%221.0%22%20?%3E%3Csvg%20width%3D%2230%22%20height%3D%2230%22%20viewBox%3D%220%200%2030%2030%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M29.9999%2014.9385C29.9669%206.68262%2023.2639%200%2015%200C6.7157%200%200%206.71582%200%2015C0%2023.2842%206.7157%2030%2015%2030C23.2639%2030%2029.9669%2023.3174%2029.9999%2015.0615C29.9999%2015.041%2030%2015.0205%2030%2015C30%2014.9795%2029.9999%2014.959%2029.9999%2014.9385Z%22%20fill%3D%22white%22/%3E%3Cpath%20d%3D%22M24.5612%2017.4695C22.9394%2017.4726%2021.6242%2016.1862%2021.6279%2014.6005C21.6316%2013.0345%2022.9474%2011.7445%2024.5473%2011.7383C26.1556%2011.732%2027.4826%2013.0349%2027.4786%2014.6162C27.4746%2016.1926%2026.1719%2017.4665%2024.5612%2017.4695ZM22.8416%2014.6183C22.8459%2015.5573%2023.6166%2016.3004%2024.5777%2016.2923C25.5165%2016.2845%2026.2699%2015.5301%2026.2673%2014.6005C26.2646%2013.6712%2025.51%2012.9317%2024.56%2012.9277C23.6012%2012.9237%2022.8373%2013.6751%2022.8416%2014.6183Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M19.5054%2010.0762H20.795V17.4217H19.9447C19.7021%2017.4217%2019.5054%2017.225%2019.5054%2016.9823V10.0762Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M18.5227%2011.8907H17.2881V12.2935C16.5767%2011.8601%2015.8509%2011.6775%2015.06%2011.831C14.2526%2011.9876%2013.6164%2012.4043%2013.167%2013.0917C12.4538%2014.1826%2012.5894%2015.5904%2013.4938%2016.5431C14.3504%2017.4454%2015.8628%2017.8178%2017.2815%2016.9247C17.2835%2016.934%2017.286%2016.9422%2017.2881%2016.9511V16.9826C17.2881%2017.2252%2017.4849%2017.422%2017.7275%2017.422H18.5227V11.8907V11.8907ZM15.5853%2016.2787C14.6636%2016.268%2013.8924%2015.5006%2013.8986%2014.6004C13.9048%2013.692%2014.6716%2012.9481%2015.602%2012.9479C16.5427%2012.9477%2017.2871%2013.6781%2017.2882%2014.6026C17.2893%2015.5333%2016.521%2016.2896%2015.5853%2016.2787Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20d%3D%22M8.0481%2016.2438C9.39854%2014.5856%2010.6939%2012.9885%2011.9984%2011.3989C12.2464%2011.0968%2012.3662%2010.7671%2012.3731%2010.3807C12.3761%2010.2135%2012.3261%2010.1646%2012.1596%2010.165C11.6056%2010.1666%206.41195%2010.165%206.41195%2010.165V11.4709H10.4978C10.4424%2011.543%207.83556%2014.7218%206.57932%2016.2403C6.37112%2016.4919%206.26503%2016.7645%206.25401%2017.0936C6.24628%2017.3242%206.28864%2017.4139%206.52267%2017.4211V17.4217H11.9356C12.1782%2017.4217%2012.3749%2017.225%2012.3749%2016.9823V16.2487V16.2438H8.0481V16.2438Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.948%2026.1338C6.03613%2027.1172%207.26917%2027.9424%208.61108%2028.5752V26.1338H4.948ZM0.00268555%2014.7119C0.0775146%2010.7393%201.69666%207.14453%204.28479%204.50293C4.0459%204.98242%203.83435%205.47949%203.64661%205.99121C2.58862%208.87598%202.31299%2011.8506%202.69116%2014.8916C2.95862%2017.042%203.55518%2019.0869%204.63391%2020.9775C4.8269%2021.3154%205.02271%2021.6582%205.26489%2021.9609C5.76672%2022.5879%205.80981%2023.2725%205.59888%2024.0049C5.4873%2024.3926%205.32227%2024.75%205.11304%2025.082C4.95691%2025.3291%204.77612%2025.5635%204.57434%2025.7842C1.81921%2023.1201%200.0819092%2019.4102%200.00280762%2015.2939C0.000976562%2015.1963%200%2015.0986%200%2015C0%2014.9033%200.000854492%2014.8076%200.00268555%2014.7119Z%22%20fill%3D%22%230068FE%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.8226%2026.3367C22.191%2028.6189%2018.7568%2029.9998%2015%2029.9998C11.1449%2029.9998%207.62952%2028.5457%204.97241%2026.156C6.32458%2026.1921%207.61877%2025.9031%208.86353%2025.3464C8.97681%2025.2957%209.06262%2025.3113%209.16443%2025.364C12.2258%2026.9646%2015.5131%2027.5125%2018.926%2027.3962C20.9574%2027.3269%2022.9333%2027.0046%2024.8226%2026.3367Z%22%20fill%3D%22%23015BDF%22/%3E%3C/svg%3E"
											alt=""></a>
								</div>
								<div v-if="page.socials && page.socials.telegram && page.socials.telegram.url">
									<a :href="page.socials.telegram.url" target="_blank">
										<img class="telegram-logo"
											src="https://omnisales.worldfone.vn/portal/assets/images/icon/telegram.png"
											alt=""></a>
								</div>
								<div v-if="page.socials && page.socials.viber && page.socials.viber.url">
									<a :href="page.socials.viber.url" target="_blank">
										<img class="viber-logo"
											src="https://omnisales.worldfone.vn/portal/assets/images/icon/viber.png"
											alt=""></a>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

			<div class="body">
				<form class="" id="form-suvey" @submit.prevent="submit_survey" ref="submit_survey">
					<div class="form_submit_survey">
						<div class=" form-suvey">
							<div v-for="(item, key) in dataFields" class="form-control" >
								<!-- {{field[item.id]}} checkedNames: {{checkedNames}} -->
								<p>
									<!-- <span>{{ (item.id =='name' || item.id =='phone' || item.id =='email') ? $t(item.id) : item.field_name }} </span> -->
									<span>{{ $t(item.field_name) }}</span>
									<span v-if="item.require=='1' " style="font-size: 1.3em;font-weight: bold;" :style="{'color':page.color}">*</span>
									<!-- <span v-if="(item.type =='text' || item.type =='') && item.id=='name' && nameErrorKey==1" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >( Họ tên không dài quá 255 ký tự )</span> -->
								</p>

								<span v-if="item.error" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >({{item.error}})</span>

								<!-- (field[item.id].length==0 || field[item.id]== undefined) -->
								<!-- <span v-if="item.id=='name' && nameErrorKey==0 && (field[item.id]== undefined || field[item.id]=='') && submitKey==1  && item.require=='1'" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >( Vui lòng nhập họ tên của bạn )</span>
								<span v-if="item.id!='name'  && (field[item.id]== undefined || field[item.id]=='' ) && submitKey==1 && item.require=='1'" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >( Vui lòng nhập <span>{{(item.field_name).toLowerCase()}}</span> )</span> -->
								
								<!-- <span v-if="checkInvalid" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >( <span>{{(item.field_name).toLowerCase()}}</span> không hợp lệ )</span> -->
								<!-- <span v-if="(item.type =='text' || item.type =='' || item.type =='textarea') && item.id!='name' && (field[item.id] != undefined  && field[item.id].length > 1024)" style="color:#c00;font-size: .7em;font-style: italic;display: block;" >( <span>{{item.field_name}}</span> không dài quá 1024 ký tự )</span> -->
								<input v-if="(item.type =='text' || item.type =='') && item.id=='name'" v-model.trim="field[item.id]" type="text" :ref="'v_'+item.id" class="input-text" @input="max_size(field[item.id])" :style="{'border-color':page.color}">
								<input v-else-if="item.type =='text' || item.type ==''" v-model.trim="field[item.id]" type="text" :ref="'v_'+item.id" class="input-text" :style="{'border-color':page.color}">
								<textarea v-else-if="(item.type =='textarea')"  rows="4" v-model.trim="field[item.id]" :ref="'v_'+item.id"  :style="{'border-color':page.color}"></textarea>
								<select v-else-if="item.type=='select'" v-model="field[item.id]" :ref="'v_'+item.id" :style="{'border-color':page.color}" >
									<option  selected  disabled value="undefined" class="optionClass">Chọn {{(item.field_name).toLowerCase()}}</option>
									<option v-for="(item1, key1) in item.data" :value="{ id: item1.value, text: item1.title }" :style="styleObject" class="optionClass">
										{{item1.title}}
									</option> 
								</select>
								<div v-else-if="item.type=='radio'">
									<div v-for="(item1, key1) in item.data">
										<label class="container-check container-radio">
											<p style="padding: 0;"><span>{{item1.title}}</span></p>
											<input type="radio" class="input-radio" :value="{ id: item1.value, text: item1.title }" v-model="field[item.id]" :ref="'v_'+item.id">
											<span class="checkmark" :style="styleObject"></span>
										</label>
										<!-- <input type="radio" :value="{ id: item1.value, text: item1.title }" v-model="field[item.id]" />
										<label for="one">{{item1.title}}</label> -->
									</div>
								</div>
								<div v-else-if="item.type=='checkbox'">
									<div v-for="(item1, key1) in item.data">
										<label class="container-check container-checkbox">
											<p style="padding: 0;"><span>{{item1.title}}</span></p>
											<input type="checkbox" class="input-checkbox" :data-item-id="item.id" @change="surveyCheckOnChange($event, { id: item1.value, text: item1.title })" :ref="'v_'+item.id">
											<span class="checkmark" :style="styleObject"></span>
										</label>
									</div>
								</div>
							</div>
						</div>
						<div class="form-suvey" style="height: initial;overflow: hidden;">
							<button v-if="nameErrorKey==1" disabled type="submit" class="btn_start_chat" :style="{'background-color':page.color}" >{{$t('title_begin_chat')}}</button>
							<button v-else :disabled="disabled_button == 1" type="submit" class="btn_start_chat" :style="{'background-color':page.color}">{{$t('title_begin_chat')}}</button>
						</div>
					</div>	
				</form><!--/.form-suvey-->
			</div>
			<div class="footer-note">
				<label class="lang-option"
					v-if="typeof page.languages !== 'undefined' && Object.keys(page.languages).length>0">
					<i :style="{'color': page.color}" class="fas fa-globe"></i> {{$t('language')}}
					<select v-model="lang" @change="setLang($event)">
						<option value="vi">Tiếng Việt</option>
						<option value="en" v-if="page.languages['en']">English</option>
						<option value="zh-CN" v-if="page.languages['zh-CN']">中文(简体)</option>
					</select>
				</label>
				<!-- <label class="lang-option"
					v-if="page.parent_user =='user_1414589598653489' || page.parent_user =='C1184' || page.parent_user =='C1504_uat' || page.parent_user =='C1504_prod'">
					<i :style="{'color': page.color}" class="fas fa-globe"></i> {{$t('language')}}
					<select v-model="lang" @change="setLang($event)">
						<option value="vi">Tiếng Việt</option>
						<option value="en">English</option>
					</select>
				</label> -->
				<template v-if="lang == 'vi' || setting_language == 'vi'">
					<div class="vietjet-privacy C1184" v-if="page.privacy && page.privacy.status && page.privacy.status != 0 && page.privacy.content && page.privacy.content != ''" style=" margin: 5px 0; ">
						<input v-model="policyChecked" @change="handleCheckboxChange" type="checkbox" id="vietjet-policyCheckbox" checked style=" accent-color: red; "> &nbsp;
						<label for="vietjet-policyCheckbox" v-html="getPrivacyContent(page.privacy.content)"></label>
					</div>
				</template>
				<template v-else-if="lang != undefined">
					<div class="vietjet-privacy C1184" v-if="page.languages[lang] && page.languages[lang].privacy && page.languages[lang].privacy.status && page.languages[lang].privacy.status != 0 && page.languages[lang].privacy.content && page.languages[lang].privacy.content != ''" style=" margin: 5px 0; ">
							<input v-model="policyChecked" @change="handleCheckboxChange" type="checkbox" id="vietjet-policyCheckbox" checked style=" accent-color: red; "> &nbsp;
							<label for="vietjet-policyCheckbox" v-html="getPrivacyContent(page.languages[lang].privacy.content)"></label>
					</div>
				</template>
				<template v-else>
					<div class="vietjet-privacy C1184" v-if="page.languages[setting_language] && page.languages[setting_language].privacy && page.languages[setting_language].privacy.status && page.languages[setting_language].privacy.status != 0 && page.languages[setting_language].privacy.content && page.languages[setting_language].privacy.content != ''" style=" margin: 5px 0; ">
							<input v-model="policyChecked" @change="handleCheckboxChange" type="checkbox" id="vietjet-policyCheckbox" checked style=" accent-color: red; "> &nbsp;
							<label for="vietjet-policyCheckbox" v-html="getPrivacyContent(page.languages[setting_language].privacy.content)"></label>
					</div>
				</template>
				<div v-if="page.hide_power_by!=1">
					<span>⚡ by </span><a class="product" target="_blank"
						href="https://worldfone.vn/dich-vu/tong-dai-contact-center-worldfone4x"> Worldfone4Omni</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	// import io from 'socket.io-client';
	import axios from 'axios';
	export default {
		props: ['page'/*,'first_component'*/],
		data() {
			return {
				user: '',
				field: [],
				checkedNames: [],
				disabled_button: 0,
				nameLength:0,
				nameErrorKey:0,
				submitKey:0,
				policyChecked: true
			}
		},
		methods: {
			handleCheckboxChange() {
				if (this.policyChecked) {
					$(".btn_start_chat").prop('disabled', false).removeClass('disabled');
				} else {
					$(".btn_start_chat").prop('disabled', true).addClass('disabled');
				}
			},
			max_size: function (value) {
				let vmLivechat = this;
				$.each(vmLivechat.dataFields, function(key, field){
					var fieldID = field.id
					if(fieldID == 'name' && vmLivechat.field[fieldID] != undefined && vmLivechat.field[fieldID].length > 255){
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_length', {field: field.field_name, length: 255});
						vmLivechat.disabled_button = 0;
						vmLivechat.nameErrorKey=1;
					}
				})
			},
			generate_uuid4: function (e) {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},
			surveyCheckOnChange: function (e, value) {
				var _vm = this;
				var item_id = event.target.getAttribute("data-item-id");
				
				var index_item = _vm.page.data_field.findIndex(item => item.id == item_id);
				
				if(e.target.checked){
					if(index_item != -1){
						var current_item = _vm.page.data_field[index_item];
						if(!current_item.value) current_item.value = [value];
						else current_item.value.push(value);
						_vm.field[item_id] = current_item.value
						_vm.page.data_field.splice(index_item, 1, current_item);
					}
				}
				else{
					if(index_item != -1){
						var current_item = _vm.page.data_field[index_item];
						var index_value = current_item.value.findIndex(current_value => current_value.id == value.id);
						if(index_value != -1) current_item.value.splice(index_value, 1);
						_vm.field[item_id] = current_item.value
						_vm.page.data_field.splice(index_item, 1, current_item);
					}
				}
			},
			sanitizeHTML: function (str) {
				return str.replace(/[<>]/g, function (char) {
					switch (char) {
						case '<': return '&lt;';
						case '>': return '&gt;';
						// case '"': return '&quot;';
						// case "'": return '&#39;';
						// case "/": return '&frasl;';
						
					}
				});
			},
			submit_survey: function (e) {
				var $self = this;
				var main_field = ["name", "email", "phone", "address", 'gender'];
				var survey_data = [];
				var properties = [];
				$self.submitKey=1;
				$($self.$refs.submit_survey).find('.require').removeClass('require');
				$.each($self.dataFields, function(key, value){
					$self.dataFields[key].error = ''
				})
				var check_ok = $self.validateFormData();
				
				for (var i in $self.dataFields) {
					var item = $self.dataFields[i];
					if($self.field[item.id] != undefined){
						if(typeof $self.field[item.id] == 'string'){
							$self.field[item.id]=$self.sanitizeHTML($self.field[item.id]);
						}
					}
					
					if (main_field.indexOf(item.id) == '-1') {
						properties.push({ id: item.id, name: `${item.field_name}`, value: $self.field[item.id], type: item.type });
					}
					else {
						if(item.id != 'gender') {
							// survey_data[item.id] = $self.field[item.id];
							survey_data.push({ id: item.id, value: $self.field[item.id], type: item.type });
						}
						else {
							// survey_data[item.id] = $self.field[item.id].id;
							survey_data.push({ id: item.id, value: $self.field[item.id].id, type: item.type });
						}
					}

					// if ((typeof $self.field[item.id] === 'undefined' || $self.field[item.id] == '') && item.require == 1 ) {
					// 	$($self.$refs['v_' + item.id]).parent().addClass('require');
					// 	check_ok = false;
					// 	this.disabled_button = 0;
					// } else {
					// 	if (main_field.indexOf(item.id) == '-1') {
					// 		properties.push({ id: item.id, name: `${item.field_name}`, value: $self.field[item.id], type: item.type });
					// 		//properties.push({ /*$$item.field_name*/ [`${item.field_name}`]: $self.field[item.id] });
					// 		if($self.field[item.id] != undefined && $self.field[item.id].length > 1024){
					// 		check_ok = false;
					// 		this.disabled_button = 0;
					// 		}
					// 	}
					// }
					// if (item.id == 'email' && $self.field[item.id] !== null && $self.field[item.id] !== undefined && !livechat.validateEmail($self.field[item.id])) {
					// 	$($self.$refs['v_' + item.id]).parent().addClass('require');
					// 	check_ok = false;
					// 	this.disabled_button = 0;
					// }

					// if (item.id == 'phone' && $self.field[item.id] !== null && $self.field[item.id] !== undefined && !livechat.validatePhone($self.field[item.id])) {
						
					// 	check_ok = false;
					// 	this.disabled_button = 0;
					// }
				}
				if (check_ok) {
					$self.disabled_button = 1;
					window.user.setProperties(properties);
					for (var i in survey_data) {
						if (survey_data[i].id == 'name') {
							window.user.setName(survey_data[i].value);
						} else if (survey_data[i].id == 'phone') {
							window.user.setPhone(survey_data[i].value);
						} else if (survey_data[i].id == 'email') {
							window.user.setEmail(survey_data[i].value);
						} else if (survey_data[i].id == 'address') {
							window.user.setAddress(survey_data[i].value);
						}
						else if (survey_data[i].id == 'gender') {
							window.user.setGender(survey_data[i].value);
						}
					}
					$self.$store.commit('set_token', $self.generate_uuid4());
					//Chổ này mới tạo st_token
					if ($self.st_token) {
						// socket.emit('submit_survey', {survey_data: {name:window.user.name, phone:window.user.phone, email:window.user.email, address:window.user.address}, properties:window.user.properties, livechat_id: livechat.getId(), st_token: livechat.getSetttinglocalStorage(livechat.getId()+'_omnichat', 'st_token')});

						axios.post('/app/v1/public/v3/submit_survey', { survey_data: { name: window.user.name, phone: window.user.phone, email: window.user.email, address: window.user.address, gender: window.user.gender}, properties: window.user.properties, attributes: $self.page.attributes, livechat_id: livechat.getId(), st_token: $self.st_token, conversation_language: livechat.getSetttinglocalStorage(livechat.getId() + '_omnichat', 'setting_language') }).then((response) => {
							if (response.data.status == 1) {
								livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', $self.st_token);
								var data = response.data.data;
								// $self.first_component = 'chat';
								// $self.$emit('first_component', 'chat');
								$self.$store.commit('set_first_component', 'chat');
							}
						}).catch(error => {
							console.log(error);
							$self.disabled_button = 0;
						});
					}

				}

			},
			minimize: function () {
				$('.h-btn').removeClass('zoomOut');
				$('.hotline-launcher').hide();
				top.postMessage({ st_popup_status: 0 }, document.referrer);
				this.$store.commit('set_show_launcher', 0);
			},
			setLang: function (event) {
				var $self = this;
				var val = event.target.value;
				this.setting_language = val;
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			getPrivacyContent: function(content){
				var regex = /\[(.*?)\]\((.*?)\)/g;
                var allDetectedText = [...content.matchAll(regex)];
                var newContent = content;
                $.each(allDetectedText, function (key, detectedText) {
                    if (detectedText != undefined && detectedText.length == 3) {
                        var url = detectedText[2];
                        var title = detectedText[1]
                        var replaceText = '<a href=' + url + ' target="_blank">' + title + '</a>'
                        newContent = newContent.replace(detectedText[0], replaceText);
                    }
                })
                return newContent;
			},
			replaceString: function(str, start, length, replacement) {
                var before = str.slice(0, start);
                var after = str.slice(start + length);
                var result = before + replacement + after;
                return result;
            },
			validateFormData: function(){
				var vmLivechat = this;
				var check_ok = true;
				$.each(vmLivechat.dataFields, function(key, field){
					var fieldID = field.id
					if (field.require == 1 && (typeof vmLivechat.field[fieldID] === 'undefined' || vmLivechat.field[fieldID] == '')) {
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_required', {field: (this.lang == 'vi') ? (field.field_name).toLowerCase() : field.field_name});
						check_ok = false;
						this.disabled_button = 0;
					}
					
					if((field.type == 'text' || field.type == '' || field.type == 'textarea') && field.id != 'name' && (vmLivechat.field[fieldID] != undefined  && vmLivechat.field[fieldID].length > 1024)){
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_length', {field: field.field_name, length: 1024});
						check_ok = false;
						this.disabled_button = 0;
					}

					if(fieldID == 'name' && vmLivechat.field[fieldID] != undefined && vmLivechat.field[fieldID].length > 255){
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_length', {field: field.field_name, length: 255});
						check_ok = false;
						this.disabled_button = 0;
					}

					if (fieldID == 'email' && vmLivechat.field[fieldID] !== undefined && !livechat.validateEmail(vmLivechat.field[fieldID])) {
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_invalid', {field: field.field_name});
						check_ok = false;
						this.disabled_button = 0;
					}

					if (fieldID == 'phone' && vmLivechat.field[fieldID] !== undefined && !livechat.validatePhone(vmLivechat.field[fieldID])) {
						$(vmLivechat.$refs['v_' + fieldID]).parent().addClass('require');
						vmLivechat.dataFields[key].error = vmLivechat.$t('error_field_invalid', {field: field.field_name});
						check_ok = false;
						this.disabled_button = 0;
					}
				})
				return check_ok;
			}
			/*sendMessage(e) {
			  e.preventDefault();
	  
			  this.socket.emit('SEND_MESSAGE', {
				user: this.user,
				message: this.message
			  });
			  this.message = ''
			}*/
		},
		created() {
		},
		mounted() {
			let windowInfo=localStorage.getItem("windowInfo");
			windowInfo=JSON.parse(windowInfo);
			// console.log('heiu')
			// console.log(windowInfo)
			// tin nhắn gởi từ admin về phải được nhận
			// hiển thị được tin nhắn lên trên giao diện
			// kiểm tra chặn people khi có khả nghi
			// chat lại cho 
			// 
			/*      room.setRoomId('húhú');
			 console.log(room.getRoomId('húhú'));
			 console.log(user.setName('duytien'));
			 console.log(user.name);*/
			/*this.socket.on('MESSAGE', (data) => {
				this.messages = [...this.messages, data];
				// you can also do this.messages.push(data)
			});*/
			/*const policyCheckbox = document.getElementById('vietjet-policyCheckbox');
			policyCheckbox.addEventListener('change', function() {
				if (policyCheckbox.checked) {
					$(".btn_start_chat").prop('disabled', false);
					$(".btn_start_chat").removeClass('disabled');
				} else {
					$(".btn_start_chat").prop('disabled', true);
					$(".btn_start_chat").addClass('disabled');
				}
			});*/
			// this.setting_language = this.$store.state.lang;
		},
		computed: {
			
			styleObject: function() {
				return {
				'--borderColor':this.page.color,
				'--color': this.page.color,
				'--colorHover': '#fff'
				}
			},
			st_token() {
				return this.$store.state.st_token;
			},
			lang() {
				return this.$store.state.lang;
			},
			count() {
				return '1';
			},
			first_component() {
				return this.$store.state.first_component;
			},
			dataFields: function(){
				return livechat.languages[this.lang].data_field;
			}
		}
	}
</script>
<style>
	/* , */
	/* option{color: #c00;} */
	/* select option:hover, 
	select option:focus, 
	select option:active 
	select:focus option::selection,
	option:checked:hover,
	option:checked   {
	  background-color:rgb(240, 240, 240) !important;
    }
	select:-internal-list-box option:checked ,select:-internal-list-box option:checked:hover,select:-internal-list-box option:hover  {
		background-color:rgb(240, 240, 240) !important;
	}
	select.decorated option:hover{
		box-shadow: 0 0 10px 100px rgb(240, 240, 240)inset !important;
	} */
	input:checked+.circle {
		background-color: var(--borderColor) !important; 
	}

	.container-checkbox .checkmark:after {
		border: solid var(--borderColor) ; 
		    border-width: 0 3px 3px 0;
	}
	.container-checkbox .checkmark {
		border: 1px solid var(--borderColor) !important; 
	}
	.container-radio .checkmark {
		border: 1px solid var(--borderColor) !important; 
	}
	.container-radio .checkmark:after {
		background: var(--borderColor) !important; 
	}
	.form-suvey .form-control select {font-style: italic;}
	#form-suvey{position: relative;
		height: 100%;
		width: 100%;
	}
	.form_submit_survey{
		/* height: 345px; */
    	/* overflow-y: scroll; */
		display: -webkit-box!important;
		display: -ms-flexbox!important;
		display: flex!important;
		-webkit-box-orient: vertical!important;
		-webkit-box-direction: normal!important;
		-ms-flex-direction: column!important;
		flex-direction: column!important;
		-webkit-box-align: center!important;
		-ms-flex-align: center!important;
		align-items: center!important;
		height: 100%;
	}
	.container-radio
	.form-suvey .form-control textarea{    width: 100%;
	  background-clip: padding-box;
	  border: 1px solid #d8d8d8;
	  border-radius: 5px;
	  padding:5px 15px;
	  margin: 0 auto;
	  font-size: 14px;
	  color: #333;
	  font-family: Roboto,sans-serif;
	  box-sizing: border-box;
	  -webkit-box-sizing: border-box;
	  -moz-box-sizing: border-box;
	  outline: none;}
	.btn_start_chat.disabled{
		cursor: not-allowed;
		opacity: 0.6;
	}
  </style>